import styled from 'styled-components';

export const StyledPassportField = styled.div`
   width: 278px;
`;
StyledPassportField.displayName = 'StyledPassportField';
